export default __webpack_public_path__ + "static/media/loading.66b25383.svg";